// Styles
import '@mdi/font/css/materialdesignicons.css';
import 'vuetify/styles';
import { VDateInput } from 'vuetify/labs/VDateInput'

// Vuetify
import { createVuetify } from 'vuetify';

export default createVuetify({
  components: {
    VDateInput,
  },
  theme: {
    defaultTheme: 'myCustomTheme',
    themes: {
      myCustomTheme: {
        colors: {
          primary: '#000000',
          secondary: '#FFC107',
          accent: '#8BC34A',
          error: '#F44336',
          info: '#2196F3',
          success: '#4CAF50',
          warning: '#FF9800',
        },
      },
    },
  },
});